import axios from 'axios';
import apiConfig from '../../api.config';

export default async function checkApiPaperlessCrendetials(hotel) {
  const {
    host,
    URIs: { checkApiCredentials },
  } = apiConfig;

  const uri = `${host}${checkApiCredentials}`.replace(':hotelId', hotel.hotelId);;

  return await axios.get(uri).then(res => res.data);
}
